import { enAgentGui } from "./en.agentGui.ts";
import { enMessages } from "./en.messages.ts";
import { enSettingsPanel } from "./en.settingsPanel.ts";
import { enWebsiteNode } from "./en.websiteNode.ts";
import { enWorkspaceAgentProbeQuota } from "./en.workspaceAgentProbeQuota.ts";
export const en = {
  common: {
    add: "Add",
    cancel: "Cancel",
    clear: "Clear",
    close: "Close",
    confirm: "Confirm",
    copy: "Copy",
    copying: "Copying...",
    copyFailed: "Copy failed",
    create: "Create",
    cut: "Cut",
    delete: "Delete",
    deleting: "Deleting...",
    download: "Download",
    copyImage: "Copy image",
    downloadImage: "Download image",
    expandImage: "Zoom image",
    imageZoomPercent: "Image zoom {{percent}}%",
    error: "Error",
    generateByAi: "Generate by AI",
    generating: "Generating...",
    info: "Info",
    loading: "Loading...",
    maximize: "Maximize",
    minimize: "Minimize",
    minimizeImage: "Minimize image",
    resetImageZoom: "Reset image zoom",
    refresh: "Refresh",
    remove: "Remove",
    removing: "Removing...",
    restore: "Restore",
    zoomInImage: "Zoom in image",
    zoomOutImage: "Zoom out image",
    resetToDefault: "Reset to Default",
    save: "Save",
    saving: "Saving...",
    settings: "Settings",
    warning: "Warning",
    defaultFollowCli: "Default (Follow CLI)",
    defaultModel: "default model",
    followCliDefault: "Follow CLI default",
    unknownError: "Unknown error",
    notAvailable: "N/A",
    paste: "Paste",
    percentUnit: "%",
    pixelUnit: "px",
    minuteUnit: "min"
  },
  workspaceWindowLayout: {
    trigger: "Window layout",
    moveAndResize: "Move & Resize",
    left: "Move to left quarter",
    right: "Move to right quarter",
    top: "Move to top half",
    bottom: "Move to bottom half",
    fullscreen: "Full Screen",
    restore: "Restore"
  },
  sidebar: {
    defaultAgent: "Default Agent",
    persistence: "Persistence",
    settings: "Settings",
    fallbackAgentLabel: "Agent",
    status: {
      working: "Working",
      standby: "Standby"
    },
    terminals_one: "{{count}} terminal",
    terminals_other: "{{count}} terminals",
    agents_one: "{{count}} agent",
    agents_other: "{{count}} agents",
    tasks_one: "{{count}} task",
    tasks_other: "{{count}} tasks"
  },
  appHeader: {
    togglePrimarySidebar: "Toggle Primary Sidebar",
    commandCenter: "Command Center",
    commandCenterHint: "Command Center ({{shortcut}})",
    commandCenterFallbackTitle: "Search",
    enterFullscreen: "Enter Full Screen",
    exitFullscreen: "Exit Full Screen",
    updateAvailableShort: "Update",
    updateAvailableTitle: "Version {{version}} is available",
    updateAvailableDetail: "Download the latest build when you are ready.",
    updateLater: "Later",
    updateDownloadNow: "Download Update",
    updateDownloadingTitle: "Downloading version {{version}} ({{percent}})",
    updateDownloadingShort: "Downloading update",
    updateDownloadProgress: "{{downloaded}} / {{total}}",
    updateMinimize: "Minimize",
    restartToUpdateShort: "Restart",
    restartToUpdateTitle: "Version {{version}} is ready to install",
    updateReadyDetail: "Restart the app to finish installing this update.",
    updateRestartLater: "Later",
    updateInstallNow: "Restart and Install"
  },
  controlCenter: {
    open: "Control Center",
    title: "Control Center",
    sidebar: "Sidebar",
    theme: "Theme",
    agentStandbyBanner: "Agent standby banner",
    on: "On",
    off: "Off"
  },
  debugWindow: {
    title: "IPC Inspector",
    subtitle: "Hidden diagnostics window for renderer-to-main IPC tracing.",
    loading: "Loading IPC records…",
    unavailable: "Debug window bridge is unavailable.",
    searchPlaceholder: "Search channel, payload, result, or error",
    countLabel: "{{count}} records",
    empty: "No IPC records captured yet.",
    noSelection: "Select a record to inspect its details.",
    actions: {
      pin: "Pin",
      unpin: "Unpin",
      clear: "Clear Records",
      export: "Export JSON",
      copySelected: "Copy Selected"
    },
    filters: {
      kindLabel: "Kind",
      kindAll: "All",
      kindInvoke: "Invoke",
      kindSend: "Send",
      statusLabel: "Status",
      statusAll: "All",
      statusOk: "OK",
      statusError: "Error",
      statusSent: "Sent"
    },
    detail: {
      summary: "Summary",
      payload: "Payload",
      result: "Result",
      error: "Error",
      channel: "Channel",
      kind: "Kind",
      status: "Status",
      startedAt: "Started At",
      completedAt: "Completed At",
      duration: "Duration",
      durationValue: "{{duration}} ms"
    }
  },
  commandCenter: {
    title: "Command Center",
    placeholder: "Search rooms and commands…",
    empty: "No results.",
    metaEsc: "Esc",
    sections: {
      commands: "Commands"
    },
    commands: {
      openSettings: "Settings",
      openSettingsHint: "Open Settings",
      showPrimarySidebar: "Show Sidebar",
      hidePrimarySidebar: "Hide Sidebar",
      togglePrimarySidebarHint: "Toggle Primary Sidebar"
    }
  },
  workspaceEmptyState: {
    title: "Create a room to start",
    description: "Each room has its own collaborative canvas and terminals.",
    action: "Create Room"
  },
  appMessage: {
    info: "Info",
    warning: "Warning",
    error: "Error"
  },
  errorBoundary: {
    title: "Something went wrong",
    description:
      "The renderer hit an unrecoverable error. Your room data is safe.",
    reload: "Reload",
    dismiss: "Dismiss"
  },
  agentRuntime: {
    working: "Working",
    standby: "Standby",
    exited: "Exited",
    failed: "Failed",
    stopped: "Stopped",
    restoring: "Starting"
  },
  persistence: {
    savedWithoutScrollback:
      "Storage quota reached; saved without terminal history.",
    savedSettingsOnly: "Storage quota reached; saved settings only.",
    unavailable: "Storage is unavailable; changes will not be saved.",
    limitExceeded: "Storage limit exceeded; unable to persist room state.",
    ioFailed: "Persistence I/O failed: {{message}}",
    failed: "Persistence failed: {{message}}",
    recoveryCorruptDb: "Persistence database was corrupted and has been reset.",
    recoveryMigrationFailed: "Persistence migration failed and has been reset."
  },
  agentHost: {
    backToHome: "Back to Home",
    shellHostWindow: {
      windowControls: "Window controls"
    },
    changeWallpaper: "Change wallpaper",
    wallpaperPanelTitle: "Wallpaper",
    wallpaperOptionDefault: "Default",
    wallpaperOptionOcean: "Ocean",
    wallpaperOptionGalaxy: "Galaxy",
    wallpaperOptionSky: "Sky",
    wallpaperOptionPeaks: "Mountain night",
    wallpaperOptionOrbit: "Earth at night",
    wallpaperOptionSand: "Sand ripples",
    wallpaperOptionDunes: "Starry dunes",
    signOut: "Sign Out",
    loggedOut: "Signed out.",
    sessionExpired: "Your session expired. Please sign in again.",
    authenticating: "Processing…",
    loginTitle: "Sign in to continue",
    loginSectionTitle: "Continue with your account",
    loginDescription:
      "Choose a provider, complete login in the browser, then return to Tutti.",
    loginBrowserHint:
      "Choose a provider, complete login in the browser, then return to Tutti.",
    loginOpeningBrowser: "Opening Browser...",
    loginContinueWithGoogle: "Continue With Google",
    loginContinueWithGitHub: "Continue With GitHub",
    loginGitHubHint:
      "GitHub may directly reuse the browser account you already signed in with.",
    emailLoginTitle: "Or use email verification",
    loginDividerOr: "Or email",
    loginAltMethodsAria: "More sign-in options",
    loginAltTabEmail: "Email code",
    loginAltTabLoginCode: "Access code",
    loginCodeTitle: "Or use an access code",
    loginCodeHint:
      "Enter a long-lived access code directly to sign in on this device.",
    loginCodePlaceholder: "Paste your access code",
    verifyLoginCode: "Confirm",
    loginCodeCompleted: "Access-code sign-in complete.",
    loginCodeRequired: "Access code is required.",
    emailPlaceholder: "name@example.com",
    emailCodePlaceholder: "6-digit code",
    emailCodeDialogTitle: "Enter the verification code",
    emailCodeDialogLead: "Verification code sent to {{email}}",
    emailCodeDigitAria: "Verification code digit {{index}}",
    emailCodeResendPrefix: "Didn't receive the verification code?",
    emailCodeResendAction: "Resend",
    sendEmailCode: "Send Code",
    sendEmailCodeSending: "Sending...",
    verifyEmailCode: "Verify Code",
    emailCodeSent: "Verification code sent.",
    emailLoginCompleted: "Email login complete.",
    emailRequired: "Email is required.",
    emailCodeRequired: "Verification code is required.",
    desktopAuthBridgeStale:
      "Desktop auth bridge is out of date. Restart Tutti and try again.",
    desktopActionErrorGeneric: "Something went wrong. Please try again.",
    desktopActionErrorGenericShort: "Something went wrong",
    desktopActionErrorUnavailable: "This feature is unavailable.",
    desktopActionErrorLoginTimedOut:
      "Login timed out. Return to Tutti and try again.",
    desktopActionErrorDesktopApiUnavailable:
      "Desktop service is still updating. Restart Tutti and try again.",
    desktopActionErrorPackageDownloadInterrupted:
      "The agent package download was interrupted. Check your network connection and retry.",
    desktopActionErrorPackageDownloadHTTPStatus:
      "The package server rejected the download. Retry later or contact support.",
    desktopActionErrorPackageDownloadInvalid:
      "The downloaded package failed integrity checks. Retry the download.",
    desktopActionErrorPackageDownloadDisk:
      "Unable to write the package cache. Check disk permissions and free space.",
    productNameCanvas: "Tutti",
    applications: {
      eyebrow: "Agent OS apps",
      title: "Applications",
      description:
        "Open the core room apps and preview common Agent OS workflows from one place",
      launchHint: "Mock apps can be opened after you enter a room",
      launchMockUnavailable: "Enter a room to open this mock application",
      categoryBasic: "Basic",
      categoryOffice: "Office",
      categoryCreation: "Creation",
      installAction: "Install",
      comingSoonAction: "Coming soon",
      installedAction: "Installed",
      issueTitle: "Tasks",
      issueDescription:
        "Create, assign, run, and review room tasks with agents",
      vibeDesignTitle: "Vibe design",
      vibeDesignDescription:
        "Draft product screens, interaction states, and visual directions",
      vibeVideoTitle: "Video creating",
      vibeVideoDescription:
        "Shape scripts, storyboards, edits, and final video direction",
      imageGenerationTitle: "Image generation",
      imageGenerationDescription:
        "Create visual concepts, generated assets, and prompt-driven image drafts",
      textEditorTitle: "Document",
      textEditorDescription:
        "Write and revise room notes, prompts, and lightweight documents",
      pptTitle: "PPT",
      pptDescription:
        "Create presentation outlines, slide drafts, and review-ready decks",
      sheetTitle: "Sheet",
      sheetDescription:
        "Track structured data, tables, calculations, and room planning lists",
      calendarTitle: "Calendar",
      calendarDescription:
        "Plan room milestones, follow-ups, reviews, and shared schedules",
      systemMonitorTitle: "System Monitor",
      systemMonitorDescription:
        "Inspect runtime health, resource signals, and workspace activity",
      codeEditorTitle: "Code Editor",
      codeEditorDescription:
        "Open source files, review changes, and prepare implementation notes",
      chatTitle: "Chat",
      chatDescription:
        "Coordinate room sessions, agent handoffs, and quick decisions",
      mockWindowStatus: "Mock application",
      mockWindowReady: "Ready for future integration",
      mockDesignPreviewTitle: "Design board",
      mockDesignPreviewBody:
        "Layout references, component states, and review notes will appear here",
      mockVideoPreviewTitle: "Video timeline",
      mockVideoPreviewBody:
        "Scenes, clips, narration, and export status will appear here",
      mockImageGenerationPreviewTitle: "Image studio",
      mockImageGenerationPreviewBody:
        "Prompts, generated previews, variations, and export history will appear here",
      mockEditorPreviewTitle: "Draft document",
      mockEditorPreviewBody:
        "Start writing room notes and agent prompts in this placeholder editor",
      mockPresentationPreviewTitle: "Slide deck",
      mockPresentationPreviewBody:
        "Slide outlines, narrative beats, and review notes will appear here",
      mockSheetPreviewTitle: "Data sheet",
      mockSheetPreviewBody:
        "Tables, calculations, filters, and room planning data will appear here",
      mockCalendarPreviewTitle: "Room calendar",
      mockCalendarPreviewBody:
        "Milestones, meetings, follow-ups, and shared schedule blocks will appear here",
      mockMonitorPreviewTitle: "Runtime signals",
      mockMonitorPreviewBody:
        "CPU, memory, network, and workspace activity signals will appear here",
      mockCodePreviewTitle: "Source workspace",
      mockCodePreviewBody:
        "Files, diffs, symbols, and implementation notes will appear here",
      mockChatPreviewTitle: "Room chat",
      mockChatPreviewBody:
        "Session threads, agent replies, and shared decisions will appear here"
    },
    workspaceTerminalsBadge_one: "{{count}} TERMINAL",
    workspaceTerminalsBadge_other: "{{count}} TERMINALS",
    workspaceCenterSearchAria: "Open room search",
    workspaceCenterSearchTitle:
      "Search nodes, partitions, and notes in this room",
    agentGui: enAgentGui,
    workspaceInsights: {
      runtimeTitle: "Runtime",
      live: "LIVE",
      treeTitle: "Tree",
      treeLead: "Runtime-visible room structure.",
      root: "root:",
      sandbox: "sandbox:",
      sessions: "sessions:",
      provider: "provider:"
    },
    workspaceFileManager: {
      breadcrumbsAria: "Breadcrumb",
      breadcrumbRoot: "Home",
      scrollBreadcrumbsLeft: "Scroll breadcrumbs left",
      scrollBreadcrumbsRight: "Scroll breadcrumbs right",
      previewPaneResizeAria: "Resize preview pane",
      name: "Name",
      modified: "Modified",
      size: "Size",
      empty: "This folder is empty",
      open: "Open",
      view: "View",
      openInBrowser: "Open in browser",
      newFile: "New file",
      newFolder: "New folder",
      upload: "Upload",
      uploadHere: "Upload here",
      downloadFile: "Download file",
      downloadArchive: "Download archive",
      delete: "Delete",
      deleting: "Deleting…",
      back: "Back",
      forward: "Forward",
      refresh: "Refresh",
      retry: "Retry",
      refreshed: "Files refreshed.",
      uploaded: "Uploaded {{count}} item(s).",
      uploadNoSelection: "No local files selected.",
      uploadFilteredSymlinks:
        "Uploaded available items; symbolic links were filtered.",
      uploadOnlySymlinks:
        "Upload canceled because the selected items were symbolic links.",
      uploadFilteredIgnored: "Uploaded after filtering ignored files.",
      uploadOnlyIgnored:
        "Upload canceled because filtering left no uploadable files.",
      uploadFilterTitle: "Detected .gitignore",
      uploadFilterBody:
        "Ignored files and common dependency, build, and cache folders will be filtered by default. Symbolic links are always filtered.",
      uploadFilterAdvanced: "Advanced settings",
      uploadFilterIncludeIgnored: "Upload files ignored by .gitignore",
      uploadFilterIncludeIgnoredHint:
        "This may include dependencies, build output, and cache files, increasing upload size and workspace storage usage.",
      uploadFilterSubmit: "Start upload",
      uploadConflictTitle: "Upload conflicts detected",
      uploadConflictBody:
        "Continuing will overwrite same-name files. Same-name folders will be merged, files with the same relative path will be overwritten, and other existing files will be kept.",
      uploadConflictMore: "+ {{count}} more",
      uploadConflictSubmit: "Continue upload",
      downloaded: "Download complete.",
      downloadCanceled: "Download canceled.",
      deleted: "Deleted {{name}}.",
      createdFile: "Created {{name}}.",
      createdFolder: "Created {{name}}.",
      createNameRequired: "Enter a name to create this item.",
      createNameInvalid: "Names cannot contain slashes.",
      copyPath: "Copy path",
      pathCopied: "Path copied.",
      copyPathFailed: "Unable to copy path: {{message}}",
      unsupportedViewTitle: "Can't preview this file",
      unsupportedViewBody: "Download {{name}} to open it locally.",
      operationFailed: "{{message}}",
      filePlaceholder: "notes.md",
      folderPlaceholder: "folder-name",
      cancel: "Cancel",
      create: "Create",
      deleteConfirm: "Delete {{name}}? This cannot be undone.",
      dropToUpload: "Drop to upload to {{path}}",
      dropToMove: "Drop to move to {{path}}",
      previewEmpty: "Select a file or folder to view details",
      previewDirectory:
        "Double-click the folder on the left to open the next level.",
      previewUnsupported: "Preview is not available for this file.",
      previewLoading: "Loading preview...",
      previewReadFailed: "Unable to load preview: {{message}}",
      previewTooLarge: "This file is too large to preview. Max {{maxSize}}.",
      previewBinary: "This file looks binary and cannot be previewed here.",
      previewDecodeFailed: "This file is not valid UTF-8.",
      minimize: "Minimize",
      maximize: "Maximize",
      restore: "Restore",
      close: "Close"
    },
    workspaceFileNode: {
      loading: "Loading file...",
      readFailed: "Unable to read file: {{message}}",
      unsupportedImage: "Unsupported image type.",
      tooLarge: "This file is too large to edit here. Max {{maxSize}}.",
      binary: "This file looks binary and cannot be edited here.",
      decodeFailed: "This file is not valid UTF-8.",
      save: "Save",
      saving: "Saving...",
      saved: "Saved",
      dirty: "Unsaved changes",
      saveFailed: "Save failed: {{message}}",
      closeUnsavedTitle: "Save changes before closing?",
      closeUnsavedBody: "{{name}} has unsaved changes.",
      saveAndClose: "Save and close",
      discard: "Discard",
      cancel: "Cancel"
    },
    workspaceRenameHint: "Click to rename room",
    workspaceRenameLabel: "Room name",
    workspaceBack: "Back",
    workspaceAgentMessageCenterTitle: "Agent messages",
    workspaceAgentMessageCenterOpenAria: "Open agent messages",
    workspaceAgentMessageCenterWaitingCount_one: "{{count}} waiting",
    workspaceAgentMessageCenterWaitingCount_other: "{{count}} waiting",
    workspaceAgentMessageCenterFilterAll: "All",
    workspaceAgentMessageCenterFilterWaiting: "Waiting",
    workspaceAgentMessageCenterFilterWorking: "Running",
    workspaceAgentMessageCenterFilterCompleted: "Completed",
    workspaceAgentMessageCenterFilterFailed: "Error",
    workspaceAgentMessageCenterViewOptions: "View options",
    workspaceAgentMessageCenterViewSummary:
      "Grouped by {{group}} · {{filters}}",
    workspaceAgentMessageCenterSummaryCount: "{{count}} messages",
    workspaceAgentMessageCenterSummaryWaiting:
      "{{count}} messages · {{waiting}} need attention",
    workspaceAgentMessageCenterSummaryCompleted:
      "{{count}} messages · {{completed}} completed",
    workspaceAgentMessageCenterSummaryFiltered:
      "Filtered · {{count}} of {{total}}",
    workspaceAgentMessageCenterFilterActive: "Filters active",
    workspaceAgentMessageCenterGroupBy: "Group by",
    workspaceAgentMessageCenterGroupPriority: "Importance",
    workspaceAgentMessageCenterGroupStatus: "Status",
    workspaceAgentMessageCenterGroupAgent: "Agent",
    workspaceAgentMessageCenterGroupTime: "Time",
    workspaceAgentMessageCenterGroupNeedsAttention: "Needs attention",
    workspaceAgentMessageCenterGroupRecentlyCompleted: "Recently completed",
    workspaceAgentMessageCenterGroupToday: "Today",
    workspaceAgentMessageCenterGroupYesterday: "Yesterday",
    workspaceAgentMessageCenterGroupPreviousSevenDays: "Previous 7 days",
    workspaceAgentMessageCenterGroupOlder: "Older",
    workspaceAgentMessageCenterFilterStatus: "Filter status",
    workspaceAgentMessageCenterFilterAgent: "Filter agent",
    workspaceAgentMessageCenterClearFilters: "Clear filters",
    workspaceAgentMessageCenterStatusQuickFilterAria:
      "Show {{status}} messages ({{count}})",
    workspaceAgentMessageCenterExpandStackAria:
      "Expand {{count}} collapsed messages",
    workspaceAgentMessageCenterCollapseStackAria: "Collapse expanded messages",
    workspaceAgentMessageCenterStackSummaryCount: "{{count}} messages",
    workspaceAgentMessageCenterFilteredEmpty:
      "No messages match the current filters",
    workspaceAgentMessageCenterEmpty: "No agent messages yet",
    workspaceAgentMessageCenterNoSummary: "No agent message yet",
    workspaceAgentMessageCenterOpenChat: "Open session",
    workspaceAgentsNoSessions: "No sessions",
    workspaceAgentsNoActivities: "No current activity",
    workspaceAgentsUntitledConversation: "Untitled conversation",
    workspaceAgentsGenericAgentName: "Agent",
    workspaceAgentsSessionCount_one: "{{count}} session",
    workspaceAgentsSessionCount_other: "{{count}} sessions",
    workspaceAgentsMemberCount_one: "{{count}} member",
    workspaceAgentsMemberCount_other: "{{count}} members",
    workspaceAgentsSummaryWorking: "working",
    workspaceAgentsSummaryNeedsAttention: "needs attention",
    workspaceAgentsSummaryOffDuty: "off duty",
    workspaceAgentsSummaryRowAria: "Member count, working, and needs attention",
    workspaceAgentsParallelSessions_one: "{{count}} in parallel",
    workspaceAgentsParallelSessions_other: "{{count}} in parallel",
    workspaceAgentStatusWorking: "Running",
    workspaceAgentStatusPaused: "Paused",
    workspaceAgentStatusWaiting: "Waiting",
    workspaceAgentStatusReady: "Ready",
    workspaceAgentStatusCompleted: "Completed",
    workspaceAgentStatusFailed: "Failed",
    workspaceAgentStatusCanceled: "Canceled",
    workspaceParticipantsTitle: "Human in this room",
    workspaceParticipantsTopbarAria: "Workspace participants",
    workspaceParticipantsInviteAria: "Invite members",
    workspaceParticipantsInviteDisabled:
      "You’re not the creator of this room, so you can’t send invites.",
    workspaceParticipantsInvitedCount_one: "{{count}} invited member",
    workspaceParticipantsInvitedCount_other: "{{count}} invited members",
    workspaceParticipantsOwnerBadge: "Owner",
    workspaceParticipantsNoAgents: "No agent has been used yet",
    workspaceParticipantsAgentCount_one: "{{count}} agent type used",
    workspaceParticipantsAgentCount_other: "{{count}} agent types used",
    workspaceParticipantsOnlineSummary_one: "{{count}} human or agent online",
    workspaceParticipantsOnlineSummary_other:
      "{{count}} humans and agents online",
    workspaceParticipantsOverflowAria: "More workspace participants",
    workspaceXagentsCollab: "xagents collaboration",
    workspaceThemeHint: "Theme & appearance",
    loadingTutti: "Loading Tutti…",
    runtimeArtifactStatus: {
      startupTitle: "Preparing the workspace runtime",
      startupDescription:
        "Tutti is preparing the local workspace runtime before login or workspace entry. This one-time setup may take a few minutes on the first launch.",
      startupProgressHint:
        "Checking local runtime files and preparing downloads.",
      downloadedOfTotal: "{{downloaded}} of {{total}}",
      progressAria: "Workspace runtime download progress",
      checking: "Preparing workspace environment…",
      downloading: "Downloading workspace environment…",
      downloadingPercent: "Downloading workspace environment… {{percent}}%",
      verifying: "Finalizing workspace setup…",
      error: "Workspace environment setup failed",
      retry: "Retry setup",
      retrying: "Retrying…",
      backgroundHint:
        "You can keep using the app. The workspace environment will be ready before you enter a workspace.",
      retryHint: "Open the workspace again to retry."
    },
    workspaceEnterStatus: {
      enterStarted: "Connecting to workspace…",
      prepareSandbox: "Preparing sandbox…",
      prepareToolchain: "Preparing toolchain…",
      ensureRuntime: "Starting workspace environment…",
      preAttachToolchain: "Installing required tools…",
      attachRuntime: "Loading workspace…",
      applyProjections: "Applying Files…",
      applyConfigOverlays: "Applying configuration…",
      syncWorkspacePatch: "Syncing workspace state…",
      enterSucceeded: "Workspace ready",
      enterFailed: "Workspace enter failed",
      resolvingCanvas: "Restoring workspace canvas…",
      finalizingWorkspace: "Finalizing workspace…"
    },
    roomRenameHint: "Click to rename room",
    roomRenameLabel: "Room name",
    roomBack: "Back",
    roomExitActiveAgentTitle: "Leave this room?",
    roomExitActiveAgentLead:
      "An agent is still working in this room. Leaving will stop the agent process and mark the task as interrupted.",
    roomExitActiveAgentConfirm: "Leave and interrupt",
    workspaceAgentSessionDetailToolCalls: "{{count}} tool calls",
    workspaceAgentSessionDetailThinking: "Thinking",
    workspaceAgentSessionDetailWorking: "Running...",
    workspaceClosingBanner:
      "This workspace is closing. Your connection will end soon.",
    workspaceClosingStatus: "Workspace shutdown in progress",
    workspaceAgentMessageExpand: "Show all",
    workspaceAgentActivityStatusWorking: "Running",
    workspaceAgentActivityStatusWaiting: "Waiting",
    workspaceAgentActivityStatusIdle: "Completed",
    workspaceAgentActivityStatusEnd: "Completed",
    workspaceAgentActivityStatusCompleted: "Completed",
    workspaceAgentActivityStatusCanceled: "Canceled",
    workspaceAgentActivityStatusFailed: "Error",
    workspaceAgentSessionDetailEmptyWithTimeline:
      "There are no displayable session messages yet.",
    workspaceAgentSessionDetailEmptyNoTimeline: "No session details yet.",
    workspaceAgentSessionDetailOpenFile: "Open {{path}}",
    shareJoin: {
      status: {
        checkingTitle: "Checking invite",
        checkingDescription: "Validating the invite code and opening the room.",
        successTitle: "Joined room",
        successDescription:
          "The workspace list has been refreshed and the room is opening.",
        fullTitle: "Room is full",
        fullDescription: "This workspace has no collaborator seats remaining.",
        usedTitle: "Invite link expired",
        usedDescription: "This invite code has already been used.",
        revokedTitle: "Invite link expired",
        revokedDescription: "This invite code has been revoked by the owner.",
        invalidTitle: "Could not join room",
        invalidDescription:
          "Check whether the link is complete, or ask the owner to generate a new invite.",
        authRequiredTitle: "Sign in required",
        authRequiredDescription:
          "Please sign in first, then reopen the invite link to continue joining.",
        defaultTitle: "Could not join room",
        defaultDescription:
          "Check whether the link is complete, or ask the owner to generate a new invite."
      },
      modal: {
        eyebrow: "Workspace Share",
        title: "Join as collaborator",
        recognizedRoom: "Recognized room",
        inviteCodePlaceholder: "Enter invite code",
        submit: "Enter room with invite code",
        submitting: "Entering..."
      }
    },
    datePicker: {
      placeholder: "Year / Month / Day",
      displayValue: "{{year}} / {{month}} / {{day}}",
      monthLabel: "{{month}} / {{year}}",
      previousMonth: "Previous month",
      nextMonth: "Next month",
      clear: "Clear",
      today: "Today",
      weekdaySun: "Sun",
      weekdayMon: "Mon",
      weekdayTue: "Tue",
      weekdayWed: "Wed",
      weekdayThu: "Thu",
      weekdayFri: "Fri",
      weekdaySat: "Sat"
    },
    collabResult: {
      title: "Collaboration result",
      actorFallback: "Collaborator",
      unread: "{{name}} marked the task as complete. Check the latest result.",
      read: "{{name}} marked the task as complete."
    },
    agentTool: {
      fallbackName: "Use tool",
      statusWorking: "Running",
      statusCompleted: "Completed",
      statusFailed: "Failed",
      statusCanceled: "Canceled",
      statusWaiting: "Waiting",
      details: {
        summary: "Summary",
        input: "Input",
        output: "Output",
        error: "Error",
        command: "Command",
        prompt: "Prompt",
        path: "Path",
        content: "Content",
        patch: "Patch",
        questions: "Questions",
        steps: "Steps",
        query: "Query",
        scope: "Scope",
        results: "Results",
        url: "URL",
        todos: "Todos",
        skill: "Skill",
        mcp: "MCP",
        mcpServer: "Server",
        mcpTool: "Tool",
        mcpItem: "Item {{index}}",
        mcpDoc: "Doc {{index}}",
        approvalOptions: "Approval options",
        answerPrefix: "Answer: {{answer}}",
        waitingForAnswer: "Waiting for answer…",
        questionFallback: "Question",
        delegateSession: "Delegate session",
        subAgents: "Sub-agents",
        subAgentStarting: "Starting…",
        subAgentQueued: "Queued — waiting for an agent slot…",
        subAgentFallbackName: "Sub-agent",
        subAgentEarlierOmitted: "{{count}} earlier steps omitted",
        subAgentTask: "TASK",
        subAgentProgress: "PROGRESS",
        missingFailureDetails: "The provider reported failure without details.",
        noMatches: "No matches",
        stepLabel: "Step {{index}}",
        noMatchingTools: "No matching tools",
        loadedAvailable: "{{loaded}} loaded · {{available}} available",
        contentTruncated: "Content truncated",
        summaryTruncated: "Summary truncated",
        rawPayload: "Raw payload",
        loadingDiff: "Loading diff…",
        imagePreviewAlt: "Image generation preview",
        showFullContent: "Show full content ({{count}} lines)",
        collapseContent: "Collapse content",
        showFullDiff: "Show full diff ({{count}} lines)"
      },
      labels: {
        runCommand: "Run command",
        readFile: "Read file",
        writeFile: "Write file",
        editFile: "Edit file",
        listFiles: "List files",
        searchFiles: "Search files",
        webSearch: "Search web",
        webFetch: "Read web page",
        applyPatch: "Apply patch",
        useTool: "Use tool",
        findFiles: "Find files",
        readCommandOutput: "Read command output",
        stopCommand: "Stop command",
        readNotebook: "Read notebook",
        editNotebook: "Edit notebook",
        updateTodos: "Update todos",
        delegateAgent: "Delegate agent",
        closeAgent: "End agent",
        waitAgent: "Wait for agent",
        currentIssue: "Current task",
        thinking: "Thinking",
        responding: "Responding",
        notification: "Notification"
      }
    },
    workspaceAgentProbeAvailableAria: "Available",
    workspaceAgentProbeUnavailableAria: "Unavailable",
    workspaceAgentProbeUnknownAria: "Status unknown",
    workspaceAgentProbeDockChecking: "Checking availability…",
    workspaceAgentProbeDockNoData: "No availability data for this room yet",
    workspaceAgentProbeDockAvailable: "Available",
    workspaceAgentProbeDetailStatus: "Status",
    workspaceAgentProbeDetailQuota: "Quota",
    workspaceAgentProbeUsageUnsupported: "Usage data not available",
    workspaceAgentProbeQuotaResetTimeLabel: "{{label}} reset time",
    ...enWorkspaceAgentProbeQuota,
    workspaceAgentProbeLoadingUsage: "Loading usage…",
    workspaceAgentProbeScrollListRight: "Show more agents",
    workspaceAgentProbeScrollListLeft: "Show previous agents",
    workspaceAgentProbeAgentUsage: "Usage",
    workspaceAgentProbeQuotaSession: "Session",
    workspaceAgentProbeQuotaWeekly: "Weekly",
    workspaceAgentProbeQuotaMonthly: "Monthly",
    workspaceAgentProbeQuotaDaily: "Daily",
    workspaceAgentProbeQuotaCost: "Cost",
    workspaceAgentProbeErrorAuthRequired: "Sign in required",
    workspaceAgentProbeErrorSessionExpired: "Session expired",
    workspaceAgentProbeErrorSubscriptionRequired: "Subscription required",
    workspaceAgentProbeErrorParseFailed: "Usage output could not be parsed",
    workspaceAgentProbeErrorNoData: "No usage data yet",
    workspaceAgentProbeErrorTimeout: "Usage probe timed out",
    workspaceAgentProbeErrorUnavailable: "Usage probe failed",
    roomParticipantsTitle: "Human in this room",
    roomParticipantsTopbarAria: "Room participants",
    roomParticipantsInviteAria: "Invite members",
    roomParticipantsInviteDisabled:
      "You’re not the creator of this room, so you can’t send invites.",
    roomParticipantsInviteOwnerOnlyTooltip:
      "Only room owners can invite members",
    roomParticipantsLeaveRoom: "Leave room",
    roomParticipantsInvitedCount_one: "{{count}} invited member",
    roomParticipantsInvitedCount_other: "{{count}} invited members",
    roomParticipantsOwnerBadge: "Owner",
    roomParticipantsNoAgents: "No agent has been used yet",
    roomParticipantsAgentCount_one: "{{count}} agent type used",
    roomParticipantsAgentCount_other: "{{count}} agent types used",
    roomParticipantsOnlineSummary_one: "{{count}} human or agent online",
    roomParticipantsOnlineSummary_other: "{{count}} humans and agents online",
    roomParticipantsOverflowAria: "More room participants",
    roomConnecting: "Preparing room…",
    roomCanvasLoadErrorTitle: "Room canvas data failed to load",
    roomCanvasLoadErrorDescription:
      "The current room canvas data could not be loaded. Refresh to try again.",
    roomCanvasLoadRetry: "Refresh",
    roomCanvasLoadRetrying: "Refreshing…",
    roomRecoveryRenderFailed:
      "Room restored from backend but failed to render workspace. Please reload.",
    runtimeConnectionLostTitle: "Runtime connection lost",
    runtimeConnectionLostSummary:
      "The managed runtime connection could not recover quickly. Restart the app to continue.",
    runtimeConnectionLostLead:
      "The app will relaunch and start a fresh local runtime.",
    runtimeConnectionRefresh: "Restart app",
    runtimeConnectionRefreshing: "Restarting…",
    runtimeConnectionRefreshSucceeded: "App restart requested.",
    roomEntryDiscarded:
      "Could not finish opening the workspace. It may have been replaced by a newer action—please try again.",
    roomEnterStatus: {
      enterStarted: "Connecting to room…",
      prepareSandbox: "Preparing sandbox…",
      prepareToolchain: "Preparing toolchain…",
      ensureRuntime: "Starting workspace environment…",
      runTemplateHook: "Running application setup…",
      preAttachToolchain: "Installing required tools…",
      attachRuntime: "Loading workspace…",
      applyProjections: "Applying files…",
      applyConfigOverlays: "Applying configuration…",
      syncWorkspacePatch: "Syncing room state…",
      enterSucceeded: "Room ready",
      enterFailed: "Room enter failed",
      resolvingCanvas: "Restoring room canvas…",
      finalizingWorkspace: "Finalizing room…"
    },
    simpleMode: {
      pageHeadline: "Collaborate with partners and Agents in one shared room",
      fusedButton: {
        main: "Create collaboration room",
        hint: "Drop files or folders to use as the starting point partners can work on together",
        hintActive: "Release to create a collaboration room with this content"
      },
      note: {
        label: "Note",
        placeholder: "What is this room for? (Optional)"
      },
      overlayStatus: {
        creating: "Preparing your shared room…",
        generatingInvite: "Room is ready. Generating the invite link…",
        done: "Entering the room…",
        error: "Something went wrong"
      },
      overlayActions: {
        retry: "Retry",
        dismiss: "Back"
      },
      inviteModal: {
        title: "Send this link to your partners",
        body: "Anyone who opens the link can join the same room and work with the content you just added.",
        linkLabel: "Invite link",
        copy: "Copy",
        copied: "Copied",
        primary: "Done",
        secondary: "Share later"
      }
    },
    workspaceConnecting: "Preparing your room…",
    unknownProvider: "Unknown provider",
    messages: {
      roomOpened: "Room opened",
      roomOpenedIssue: "Room opened. Preparing to focus the task.",
      issueTitleRequired: "Enter a task title first",
      issueCreated: "Task created",
      issueUpdated: "Task updated",
      issueShareLinkCopied: "Task share link copied",
      issueShareFallbackRoomFull:
        "This room is full. Copied a task link that only current room members can open.",
      issueShareFallbackInviteFull:
        "Invite link capacity is full. Copied a task link that only current room members can open.",
      issueWorkspaceNotReady:
        "The current room workspace is not ready yet. Please try again soon.",
      issueRunSessionUnavailable:
        "This run is not linked to a replayable session",
      issueDetailRequiredBeforeRun:
        "Open the task details before starting the run",
      issueNoAvailableAgent: "There is no available Agent right now",
      issueRunStarted: "Sent to {{provider}}. Adjust before running.",
      issueStatusUpdated: "Task status updated",
      issueDeleteForbidden: "Only the task creator can delete this task",
      issueNotFoundOrDeleted:
        "The task does not exist or has already been deleted",
      issueDeleted: "Task deleted",
      issueContextAdded: "Reference files added",
      issueContextRemoved: "Reference file removed",
      issuePendingUploadAdded: "Added {{count}} pending upload file(s)",
      issueUploaded: "Uploaded {{count}} file(s)",
      issueDirectInstallUnsupported:
        "Installing Agents is not supported here yet",
      collabCompleted: "This collaboration task is complete",
      githubLoginCompleted: "GitHub sign-in complete",
      googleLoginCompleted: "Google sign-in complete"
    },
    issue: {
      sidebarEyebrow: "Task center",
      sidebarTitle: "Tasks",
      sidebarHint:
        "Everyone in the room can review tasks and jump to collaboration work quickly.",
      sidebarResizeAria: "Resize task list",
      create: "Create task",
      loading: "Loading tasks...",
      empty: "There are no tasks yet. Create one to start collaborating.",
      metaPriority: "Priority {{value}}",
      metaDue: "Due {{value}}",
      stageEyebrow: "Task flow",
      stageTitle:
        "Use tasks to connect context, execution, and outputs in one flow.",
      stageDescription:
        "Create a task in the room, attach Files for context, then let a collaborator run it manually with their own Agent.",
      shareThisIssue: "Share this task",
      flowList: "Browse tasks",
      flowCreate: "Create task",
      flowContext: "Reference Files",
      flowDetail: "Review details",
      flowRun: "Choose how to run",
      flowOutput: "Review outputs",
      currentFocusTitle: "Current focus",
      currentFocusSubtle:
        "The selected task is summarized here so you can move to the next step quickly.",
      currentFocusEmpty:
        "Select a task from the left, or create a new one to start the run flow.",
      defaultDescription:
        "Add background, symptoms, and expected outcomes so collaborators can pick this up more easily.",
      metricReferences: "References",
      metricRunHistory: "Run history",
      metricOutputs: "Latest outputs",
      countFiles: "{{count}} file(s)",
      countRuns: "{{count}} run(s)",
      executionModeTitle: "How to run",
      executionModeSubtle:
        "V1 uses one path: open the shared task, then run it manually with your own Agent.",
      executionMyAgentTag: "My Agent",
      executionMyAgentDescription:
        "Start a run directly from the detail view and write results back into Files.",
      executionShareTag: "Share link",
      executionShareDescription:
        "Bring collaborators to the same task so they can click run themselves. V1 does not auto-run for others.",
      outputsTitle: "Outputs",
      outputsSubtle:
        "After a run finishes, the summary, recent runs, and Files complete the loop.",
      outputsEmpty: "No execution outputs yet.",
      fileFallback: "file",
      detailEyebrow: "Task detail",
      collapse: "Collapse",
      detailLoading: "Loading details…",
      overviewTitle: "Overview",
      overviewSubtle:
        "After creation, open the detail view, attach references, and decide who should run it.",
      runWithMyAgent: "Run with my Agent",
      rerunWithMyAgent: "Run again with my Agent",
      summaryPriority: "Priority",
      summaryDueDate: "Due date",
      summaryReferences: "References",
      summaryRunHistory: "Run history",
      noDescription: "No description yet",
      shareTipCanInvite:
        "You can share this with collaborators inside or outside the room. The first open will jump into this task automatically.",
      shareTipRoomFull:
        "This room is full, so only current room members can open this task from the link.",
      referencesTitle: "Reference files",
      referencesSubtle:
        "Choose context files from the Room Workspace and attach them to this task.",
      addReferences: "Reference Files",
      referencesEmpty:
        "There are no reference files yet. Add context before running.",
      runResultTitle: "Run result",
      prepareRunTitle: "Prepare to run",
      runResultSubtle:
        "Review the latest run, outputs, and run history, and start another run if needed.",
      prepareRunSubtle:
        "After creation, finish adding references here, then decide how to run it.",
      runHeroTitle: "My Agent · Run {{runId}}",
      runSummaryEmpty: "No run result yet",
      runStatusRunning: "Run in progress. Waiting for the latest update.",
      runStatusCompleted: "The run finished without a returned summary yet.",
      runStatusFailed: "The run failed without an error summary yet.",
      runDetailsLoading: "Loading run details…",
      runOutputsEmpty: "Output files will appear in Files shortly.",
      prerunEmpty:
        "There are no run records yet. Add reference files first, then click “Run with my Agent”.",
      shareWithCollaborator: "Share link with collaborator",
      historyTitle: "Run history",
      historyHint: "Click to switch to that run result",
      currentRunOutputsTitle: "Outputs from this run",
      currentRunOutputsSubtle:
        "Run outputs are written back into Files so you can preview and reuse them.",
      currentRunOutputsEmpty: "There are no output files for this run yet.",
      directoryViewTitle: "Directory view",
      directoryViewSubtle:
        "If a run produces a directory, the files under that directory will appear here.",
      directoryViewEmpty: "There is no output directory to mirror yet.",
      directoryKind: "DIR",
      fileKind: "FILE",
      createTitle: "Create task",
      createSubtle: "Describe the request so the task is ready to run.",
      fieldTitle: "Title",
      titlePlaceholder: "Enter a task title",
      fieldDescription: "Description",
      descriptionPlaceholder:
        "Add background, symptoms, impact, and the expected result",
      descriptionPlaceholderLegacy:
        "Describe the background, symptoms, and expected result.",
      fieldPriority: "Priority",
      priorityOptionMedium: "Medium",
      priorityOptionHigh: "High",
      priorityOptionLow: "Low",
      fieldDueDate: "Due date",
      attachmentsOptional: "References (optional)",
      attachmentsEmpty: "No references added yet",
      createReferencesTitle: "Reference Files",
      createReferencesSubtle:
        "Choose context files from the Room Workspace and attach them to this task.",
      selectReferences: "Select references",
      selectionNone: "No files selected",
      selectionCount: "{{count}} file(s) selected",
      selectionEmpty: "No references selected yet.",
      saveIssue: "Save task",
      contextPickerCreateTitle: "Reference Files",
      contextPickerDetailTitle: "Add reference files",
      contextPickerSubtle:
        "Choose execution context files from the Room Workspace.",
      contextPickerEmpty: "No files selected yet.",
      completeReferences: "Finish selecting",
      addToIssue: "Add to task",
      addingToIssue: "Adding...",
      dueDateUnset: "Not set",
      runTimeJustNow: "Just now",
      createdJustNow: "Just created",
      searchPlaceholder: "Search tasks...",
      sidebarEmpty: "Tasks from this room will appear here",
      sidebarCategoryEmpty: "There are no tasks in this category",
      searchEmptyTitle: "No matching tasks",
      searchEmptyDescription: "Try a different keyword.",
      defaultEmptyTitle: "No tasks yet",
      defaultEmptyDescription:
        "Create a task, add requirements and related files, then ask a collaborator or your own Agent to run it.",
      defaultSelectTitle: "Choose a task",
      defaultSelectDescription:
        "Open a detail view from the list on the left, or create a new collaboration task.",
      editTitle: "Edit task",
      uploadFile: "Upload file",
      uploadFolder: "Upload folder",
      referenceWorkspaceFiles: "Reference Files",
      pendingUploadArchiveHint:
        "After the task is created, this will be archived into the references folder",
      latestExecutionTitle: "Latest run status",
      executionRecordsTitle: "Run history",
      viewDetails: "View details",
      copyLink: "Copy link",
      copyingLink: "Copying...",
      inviteCollaborator: "Invite collaboration",
      shareWithCollaboratorHint:
        "Share it with a collaborator so they can run it with their own Agent.",
      summaryTitle: "Summary",
      outputsTitleLegacy: "Outputs",
      filePickerTitle: "Choose references to add to the task",
      searchRoomFilesPlaceholder: "Search Files...",
      noReferenceFiles: "No reference files available",
      selectReferenceRequired: "Select at least one file to reference",
      expandItem: "Expand {{label}}",
      collapseItem: "Collapse {{label}}",
      toggleSelection: "Toggle selection for {{label}}",
      selectionCountShort: "{{count}} selected",
      currentPreview: "Current preview",
      previewPrompt: "Choose a reference on the left to preview it",
      previewPromptCompact: "Choose a reference above to preview it",
      filePickerDirectoryPreview:
        "Choose another file on the left to preview it",
      filePickerDirectoryPreviewCompact:
        "Choose another file above to preview it",
      contextEmpty: "No reference files yet",
      openReference: "Open reference {{label}}",
      outputsEmptyCompact: "No outputs yet",
      openOutput: "Open output {{label}}",
      scrollFiltersLeft: "Scroll task categories left",
      scrollFiltersRight: "Scroll task categories right",
      edit: "Edit",
      runStarting: "Starting...",
      runtimeUnavailable: "The current runtime is unavailable",
      unavailable: "Unavailable",
      install: "Install",
      installing: "Installing...",
      sync: "Sync",
      syncing: "Syncing...",
      filterAll: "All",
      statusAriaLabel: "Task status",
      priorityAriaLabel: "Task priority",
      metaCreator: "Creator {{value}}",
      metaCreatedAt: "Created {{value}}",
      metaDueAt: "Due {{value}}",
      metaCompletedAt: "Completed {{value}}",
      requesterFallback: "User",
      agentCodex: "Codex",
      agentClaudeCode: "Claude Code",
      agentTutti: "Tutti",
      agentHermes: "Hermes",
      agentOpenClaw: "OpenClaw",
      statusNotStarted: "To run",
      statusRunning: "Running",
      statusPendingAcceptance: "Pending acceptance",
      statusCompleted: "Completed",
      statusFailed: "Run failed",
      statusCanceled: "Canceled",
      priorityHigh: "High",
      priorityMedium: "Medium",
      priorityLow: "Low"
    },
    roomIssueNode: {
      statusTabAll: "All",
      statusTabNotStarted: "To run",
      statusTabRunning: "Running",
      statusTabPendingAcceptance: "Pending acceptance",
      statusTabCompleted: "Completed",
      emptyContent: "No content yet",
      taskCount_one: "{{count}} sub-task",
      taskCount_other: "{{count}} sub-tasks",
      taskCountEmpty: "No sub-tasks",
      taskRunningCount: "{{count}} running",
      taskPendingAcceptanceCount: "{{count}} pending acceptance",
      taskCompletedCount: "{{count}} completed",
      issueStatusNotStarted: "Todo",
      issueStatusRunning: "Running",
      issueStatusInProgress: "Running",
      issueStatusPendingAcceptance: "In review",
      issueStatusCompleted: "Done",
      issueStatusFailed: "Failed",
      issueStatusCanceled: "Canceled",
      issueStatusUnknown: "Unknown status",
      runStatusRunning: "Running",
      runStatusCompleted: "Completed",
      runStatusFailed: "Failed",
      runStatusCanceled: "Canceled",
      runStatusIdle: "Idle",
      issueTitleRequired: "Enter a task title",
      taskTitleRequired: "Enter a task title",
      selectTaskFirst: "Select a task first",
      deleteTaskDialogTitle: "Delete task",
      deleteTaskConfirm: "Delete task “{{title}}”?",
      deleteIssueDialogTitle: "Delete task",
      deleteIssueConfirm: "Delete task “{{title}}”?",
      issueTaskUnavailable:
        "This task is missing its parent task. The action is unavailable right now.",
      shareCopied: "Invite link copied",
      outputOpenUnavailable: "There is no output to open right now",
      sessionUnavailable: "There is no session to open right now",
      editTask: "Edit task",
      createTask: "New task",
      taskEditorLead:
        "Add a task title and description so execution can continue.",
      taskTitlePlaceholder: "Enter a task title",
      taskContentPlaceholder:
        "Add the background, goal, and acceptance criteria",
      saveTask: "Save task",
      cancel: "Cancel",
      noTaskTitle: "No tasks yet",
      noTaskDescription:
        "Create a task, add requirements and related files, then ask a collaborator or your own Agent to run it",
      favoriteTask: "Favorite task",
      creator: "Created by",
      createdAt: "Created at",
      edit: "Edit",
      delete: "Delete",
      description: "Description",
      emptyTaskContent: "No task description yet",
      emptyIssueContent: "No task description yet",
      references: "Reference files",
      emptyReferences: "No reference files yet",
      editIssue: "Edit task",
      createIssue: "Add task",
      issueTitlePlaceholder: "Enter a task title",
      issueContentPlaceholder:
        "Add the task goal, execution method, and acceptance criteria",
      saveIssue: "Save task",
      issueSelectionHint:
        "Select a task to view its details and Agent execution state.",
      timeLabel: "Time {{value}}",
      updatedAtLabel: "Updated at",
      runNotStarted: "No execution records yet.",
      issueDetailsLoading: "Loading task details…",
      agentExecution: "Agent execution",
      noIssuesTitle: "There are no tasks yet",
      noIssuesTaskShellDescription:
        "You can continue adding sub-tasks around the current task theme",
      taskExecutionTitle: "Task execution in progress",
      taskExecutionDescription:
        "Current progress appears here. Add a task any time you need to supplement a new direction.",
      deleteIssue: "Delete task",
      searchPlaceholder: "Search tasks",
      refreshTasksAria: "Refresh task list",
      collapseTaskList: "Collapse task list",
      expandTaskList: "Expand task list",
      noTasksForFilterTitle: "No tasks match the current filters.",
      noTasksForFilterBody: "Try another filter, or create a new task.",
      loadMore: "Load more",
      issuesSection: "Sub-tasks",
      createSubtask: "Add",
      createSubtaskTitle: "Add sub-task",
      editSubtask: "Edit sub-task",
      saveSubtask: "Save sub-task",
      issueTableTitle: "Title",
      issueTableDescription: "Description",
      issueTableStatus: "Status",
      issueTableOwner: "Owner",
      issueTableTime: "Time",
      issueTableActions: "Actions",
      unassigned: "Unassigned",
      view: "View",
      share: "Share",
      run: "Run",
      inviteCollaborator: "Invite collaboration",
      askAgentToRun: "Send to Agent",
      moreActions: "More actions",
      closeIssueDrawerAria: "Close task details drawer",
      runWithProvider: "Run with {{provider}}",
      noIssues: "There are no sub-tasks for this task yet.",
      noManualIssues: "Add a sub-task to track follow-up work here.",
      currentMember: "Me",
      closeWindowAria: "Close {{title}}"
    },
    workspaceSidebarRuntimeTitle: "Runtime",
    workspaceSidebarRuntimeDescription: "Live context for the current canvas.",
    workspaceSidebarLiveBadge: "Live",
    workspaceSidebarRootPrefix: "Root:",
    workspaceSidebarSandboxPrefix: "Sandbox:",
    workspaceSidebarSessionsPrefix: "Sessions:",
    workspaceSidebarProviderPrefix: "Provider:",
    workspaceSidebarTreeTitle: "Directory tree",
    workspaceSidebarTreeDescription: "Runtime-visible room structure.",
    workspaceSidebarTreeKindDir: "Directory",
    workspaceSidebarTreeKindFile: "File",
    workspaceSidebarProfileMe: "Me",
    profile: {
      openMenu: "Open account menu",
      accountSettings: "User info",
      accountSettingsTitle: "User info",
      accountSettingsLead:
        "Update how your name and avatar appear across rooms.",
      accountSettingsNameLabel: "Display name",
      accountSettingsNamePlaceholder: "Enter your display name",
      accountSettingsAvatarLabel: "Avatar",
      accountSettingsUpload: "Upload image",
      accountSettingsDefaultAvatars: "Default avatars",
      accountSettingsInvalidImage: "Choose a valid image file.",
      accountSettingsImageTooLarge: "Image must be 2 MB or smaller.",
      accountSettingsCropTitle: "Crop avatar",
      accountSettingsCropZoom: "Zoom",
      accountSettingsCropRotation: "Rotate",
      accountSettingsCropCancel: "Cancel crop",
      accountSettingsCropApply: "Use image",
      accountSettingsSaved: "Account settings saved.",
      themeSystem: "Match system",
      themeLight: "Light",
      themeDark: "Dark",
      language: "Language",
      logout: "Sign out",
      logoutDone: "Signed out of the local demo account",
      labTitle: "Lab",
      labDirectVMTerminalTitle: "VM Terminal",
      labDirectVMTerminalDescription:
        "Show a launcher entry that opens a shell directly inside the managed Linux VM",
      labDebugTerminalTitle: "Debug Terminal",
      labDebugTerminalDescription:
        "Show the workspace-bound debug terminal in room dock"
    },
    launch: {
      navLaunch: "Start",
      navTemplates: "Templates",
      navManageAgents: "Manage agents",
      navConnectors: "Connectors",
      navVMTerminal: "VM Terminal",
      vmTerminalStarting: "Starting VM...",
      vmTerminalRetry: "Retry",
      vmTerminalSessionLost: "VM terminal session was lost.",
      vmTerminalProcessExited: "[process exited with code {{exitCode}}]",
      manageAgentsTitle: "Agents",
      dock: {
        agentNotInstalled: "No local settings found. Sync after local setup.",
        agentNotSynced: "Local settings found. Sync now?"
      },
      manageAgentsGuideLead:
        "Syncing or removing only affects Tutti; agents on your computer are unchanged.",
      manageAgentsColumnAgent: "Agent",
      manageAgentsColumnRun: "Runs in",
      manageAgentsColumnInstallStatus: "Status",
      manageAgentsColumnSettings: "Settings",
      manageAgentActionInstall: "Sync",
      manageAgentActionSync: "Sync",
      manageAgentActionSyncTooltip:
        "Your local settings will be synced automatically",
      manageAgentRuntimeArtifactPreparingTooltip:
        "Workspace environment is still preparing. Sync will be available after it finishes.",
      manageAgentActionUninstall: "Remove",
      manageAgentActionInstalling: "Syncing...",
      manageAgentActionSyncing: "Syncing...",
      manageAgentActionRetry: "Retry",
      manageAgentActionUninstalling: "Removing...",
      manageAgentActionUninstallWaiting: "Waiting...",
      manageAgentUninstallConfirm:
        "This only removes {{name}} from Tutti. Apps, sign-in, and settings outside Tutti are not changed.",
      manageAgentCellRunsLocal: "Tutti local",
      manageAgentCellInstalled: "Synced",
      manageAgentCellNotInstalled: "Not synced",
      manageAgentUninstallWaiting: "Waiting to remove",
      manageAgentUninstallRemoving: "Removing",
      manageAgentDownloadDownloading: "Downloading {{agent}} · {{percent}}",
      manageAgentDownloadRetrying: "Retrying download · {{attempt}}/{{max}}",
      manageAgentDownloadFailed: "Download failed",
      manageAgentDownloadWaitingInstall: "Waiting to install",
      manageAgentDownloadInstalling: "Installing",
      manageAgentConfigWillUse: "Local settings found",
      manageAgentConfigWillSyncFrom:
        "After sync, Tutti will use {{agent}} settings from {{device}}",
      manageAgentConfigSynced: "Synced · {{time}}",
      manageAgentConfigSyncedNoTime: "Synced",
      manageAgentConfigSyncedFrom: "Synced from {{device}} to Tutti · {{time}}",
      manageAgentConfigSyncedFromNoTime: "Synced from {{device}} to Tutti",
      manageAgentConfigNone: "No settings",
      manageAgentConfigNotDetected: "No local settings found",
      manageAgentMissingHostConfigTooltip:
        "{{agent}} depends on your local installation. Finish local setup before syncing.",
      manageAgentTuttiDefaultConfig: "Tutti default settings",
      manageAgentHostDeviceFallback: "this computer",
      manageAgentSyncTimeJustNow: "just now",
      manageAgentSyncTimeMinutesAgo: "{{count}} minutes ago",
      manageAgentSyncTimeHoursAgo: "{{count}} hours ago",
      manageAgentSyncTimeDaysAgo: "{{count}} days ago",
      manageAgentsOpenclawHint:
        "To use OpenClaw in rooms, sync OpenClaw from Manage Agents.",
      kicker: "Tutti · Desktop",
      promoBadge:
        "You currently have {{count}} available agents, you can use them inside rooms.",
      promoBadgeNavigateAria:
        "Go to Manage agents—you currently have {{count}} available agents",
      heroTitle: "Real-Time Collaborative OS for Humans and Agents",
      updateAction: "Update",
      updateInstallingAction: "Relaunch to Update",
      updateDownloadingAction: "Updating {{percent}}",
      updateCardAvailableTitle: "Version {{version}} is available",
      updateCardAvailableDetail:
        "Download the latest build whenever you are ready.",
      updateCardDownloadingTitle: "Downloading {{version}}",
      updateCardDownloadingDetail:
        "The update package is downloading in the background.",
      updateCardDownloadedTitle: "Update is ready to install",
      updateCardDownloadedDetail:
        "Restart Tutti to finish installing version {{version}}.",
      updateCardDownloadAction: "Download Update",
      updateCardInstallAction: "Restart and Install",
      sectionSpacesTitle: "Rooms",
      sectionAgentsTitle: "Agents",
      sectionAgentsAction: "Manage",
      sectionAgentsEmpty: "You do not have any available Agents yet",
      sectionAgentsInstallAction: "Install now",
      viewAllRooms: "View all",
      roomsExpand: "Show {{count}} more",
      roomsCollapse: "Show less",
      roomsLoadMore: "Load more",
      roomsEmptyPlaceholder: "No rooms created or joined yet",
      recommendedTemplatesTitle: "Scenario templates",
      recommendedTemplatesViewMore: "More",
      topRailOpenCreateAria: "Create a new room—enter the name in the dialog",
      topRailOpenJoinAria:
        "Join an existing room—paste the share link in the dialog",
      roomCardStatusActive: "In progress",
      roomCardStatusIdle: "Idle",
      roomCardStatusFailed: "Failed",
      roomCardPreviewActorUser: "User",
      roomCardPreviewPlaceholder: "No latest status in this room",
      roomCardSnapshotAria: "Latest visible room state for {{name}}",
      roomCardHumansCount_one: "{{count}} human",
      roomCardHumansCount_other: "{{count}} humans",
      roomCardAgentsCount_one: "{{count}} agent",
      roomCardAgentsCount_other: "{{count}} agents",
      roomCardOnline: "online",
      roomCardAgentFallback: "Agent",
      roomCardAgentsAria: "{{count}} active agents in {{name}}",
      roomCardOpenRoomAria: "Open room {{name}}",
      roomCardMoreActions: "Room actions",
      roomCardRenameWorkspace: "Rename",
      roomRenameDialogTitle: "Rename room",
      roomRenameDialogLead: "Enter a new display name for this room.",
      roomRenamePlaceholder: "Room name",
      roomCardAvatarsAria: "Participant avatars for {{name}}",
      roomsDirectoryLead: "Browse and open every room you have joined.",
      roomsDirectoryEmpty:
        "No rooms yet. Create or join a room from the Start page.",
      sectionTemplatesTitle: "Agent arena",
      sectionOfficeSpaceTitle: "Office",
      officeScenario1Title: "OPC one-person team",
      officeScenario1Description:
        "Command multiple agents from one place to power through complex work efficiently",
      officeScenario2Title: "Collaborative delegation",
      officeScenario2Description:
        "Send tasks to agents on a friend's machine and tackle reimbursements, filing, and other chores together—with optional direct physical-terminal connections for stronger security.",
      taskCenterTitle: "Collaborative delegation",
      taskCenterDescription:
        "Start a fresh room and jump into a shared task board to sort, assign, and track work together.",
      officeScenario3Title: "Organization-wide collaboration",
      officeScenario3Description:
        "Many people and many agents collaborate in real time—process and outcomes shared across the organization",
      sectionCollaborateSpaceTitle: "Development & delivery",
      sectionContentCreationSpaceTitle: "Content creation",
      sectionMore: "More",
      sectionMoreAriaComingSoon: "More, coming soon",
      sectionMoreComingSoonHint: "Coming soon",
      betaGateCheckingTitle: "Checking beta access",
      betaGateCheckingBody:
        "We are confirming whether this account already has access to Tutti beta.",
      betaGateBlockedTitle: "This account does not have beta access yet",
      betaGateBlockedBody:
        "Enter your invite code to unlock the Tutti desktop beta.",
      betaGateInviteCodeLabel: "Invite code",
      betaGateInviteCodePlaceholder: "Enter invite code",
      betaGateInviteCodeRequired: "Enter an invite code before continuing.",
      betaGateRetry: "Recheck",
      betaGateSubmit: "Verify invite code",
      betaGateBackToLogin: "Sign out",
      betaGateSubmitting: "Verifying…",
      betaGateSubmitSuccess: "Invite code accepted",
      betaGateSubmitFailed: "Failed to verify invite code.",
      betaGateLoadFailed: "Failed to load beta access status.",
      scenarioCloneUseHint: "Clone and use scenario templates",
      contentScenario1Title: "Product prototypes",
      contentScenario1Description:
        "Product managers, designers, and intelligent agents work in sync to quickly deliver prototypes that closely match requirements.",
      contentScenario2Title: "Slide decks",
      contentScenario2Description:
        "Multiple intelligent agents collaborate—from outline and design to layout—for polished results in one flow.",
      contentScenario3Title: "Video creation",
      contentScenario3Description:
        "Different agents work together, generating scripts, storyboards, and edits in real time to ship high-quality video fast.",
      templatesLoading: "Loading scenario templates…",
      templatesLoadFailed: "Failed to load scenario templates.",
      templatesRetry: "Retry",
      templatesEmpty: "No scenario templates available right now.",
      templatePlayCta: "Try it",
      collaborateSlotHoverCta: "Coming soon",
      scenarioBadgeCollaborate: "Collaborate",
      scenarioBadgeGame: "Game",
      templateVersion: "Version {{version}}",
      templatePlaceholderTitle: "Scenario template",
      templatePlaceholderHint: "Coming soon",
      templateGomokuTitle: "Gomoku match",
      templateGomokuDescription:
        "AI helps you decide and refine every move—push your mental edge in sharp tactical play.",
      templateTexasHoldemTitle: "Texas Hold'em poker",
      templateTexasHoldemDescription:
        "AI fights alongside you, analyzing and adjusting strategy in real time—poker smarts and mind games on full display.",
      templateChineseChessTitle: "Chinese chess match",
      templateChineseChessDescription:
        "Deep AI strategy guidance and human-like play—full human-vs-machine matchup.",
      collaborateDemoBuildTitle: "Daily development",
      collaborateDemoBuildDescription:
        "A unified collaborative environment for the entire team—tasks and context flow naturally",
      collaborateDevAcceptanceTitle: "Automated testing & acceptance",
      collaborateDevAcceptanceDescription:
        "Automatically provisions a test environment so the room can run tests and acceptance quickly",
      collaborateUnifiedWorkbenchTitle: "Unified workbench",
      collaborateUnifiedWorkbenchDescription:
        "Integrate apps and agents to orchestrate and execute tasks from one place",
      intentCreateTitle: "Create a New Room",
      intentCreateBody: "Invite partners and their AI agents to collaborate",
      intentLocalDirTitle: "Join an Existing Room",
      intentLocalDirBody: "Paste the shared link to access the room",
      intentCreateSecondaryCta: "Create",
      intentJoinSecondaryCta: "Join with link",
      agentToolNameOpenclaw: "OpenClaw",
      agentToolNameClaudeCodeRouter: "Claude Code Router",
      openclawBlockTitle: "Need OpenClaw?",
      openclawBlockBody:
        "One click enables it and saves. The next time you use Create & enter on the Start page, we install and wire it in. If it is already installed, we will keep it on for new rooms by default.",
      openclawOneClickCta: "Enable OpenClaw",
      openclawEnabledHint: "On — will be included for new rooms",
      openclawOneClickSaveDone: "OpenClaw enabled and saved",
      headline: "Start from a room canvas",
      lead: "Spin up an isolated runtime for terminals and agents. Name your room to open the canvas, connect to an existing ID, or resume from recents.",
      step1: "Create a room to get an isolated runtime and sandbox directory.",
      step2:
        "Arrange terminals, tasks, and docs on the canvas; organize by partition.",
      step3: "Open the canvas to run terminals and agents in your room.",
      cardTitle: "Create a room",
      cardHint:
        "Pick a name you’ll recognize in history and when collaborating.",
      namePlaceholder: "e.g. acme-web-refactor",
      creating: "Creating…",
      createCta: "Create & open canvas",
      recentTitle: "Recent",
      joinWorkspaceCancel: "Cancel",
      joinLinkPlaceholder: "Paste share link",
      joinLinkSubmit: "Enter Now",
      joinLinkParseError: "We could not read that. Paste a valid link.",
      joinInviteCodeNextHint: "Room recognized. Enter the invite code to join.",
      runtimeEntryNamePlaceholder: "Enter room name",
      runtimeEntryCreating: "Working…",
      intentEntryModalConfirm: "Confirm",
      runtimeEntryCheckingBetaAccess: "Checking beta access",
      runtimeEntryCreateSubmit: "Start Now",
      sidebarWorkspace: "My rooms",
      sidebarRecents: "Recents",
      sidebarNoRecents: "No recent rooms yet.",
      ownedWorkspaces: "My rooms",
      sharedWorkspaces: "Shared with me",
      recentWorkspaces: "Recent rooms",
      unnamedWorkspace: "Untitled Room",
      workspaceRoleOwner: "Owner",
      workspaceRoleCollaborator: "Collaborator",
      sidebarSearchPlaceholder: "Search…",
      sidebarNewWorkspace: "New room",
      resizeSidebar: "Resize sidebar",
      sidebarDeleteWorkspace: "Delete room",
      sidebarDeleteWorkspaceConfirmTitle: "Delete this room?",
      sidebarDeleteWorkspaceConfirm:
        "“{{name}}” will be deleted for everyone in this room. This action cannot be undone.",
      sidebarDeleteWorkspaceSuccess: "Room deleted.",
      sidebarDeleteWorkspaceForbidden:
        "Only the room owner can delete this room.",
      sidebarDeleteWorkspaceNotFound: "This room no longer exists.",
      sidebarLeaveWorkspace: "Leave room",
      sidebarLeaveWorkspaceConfirmTitle: "Leave this room?",
      sidebarLeaveWorkspaceConfirm:
        "You will leave “{{name}}”. You can rejoin later if you still have access.",
      sidebarWorkspaceAgents_one: "{{count}} agent",
      sidebarWorkspaceAgents_other: "{{count}} agents",
      sidebarWorkspaceDemoOnly: "Demo",
      createWorkspacePaneTitle: "Create a room",
      createWorkspacePaneLead: "A room is where local agents collaborate.",
      createWorkspaceNameLabel: "Enter room name",
      createWorkspaceSourceDirectory: "Source directory",
      createWorkspaceSourceBrowse: "Browse…",
      createWorkspaceSourceHint:
        "Agents will have read + write access to this folder.",
      createWorkspaceVisibility: "Visibility",
      createWorkspaceVisibilityPrivate: "Private",
      createWorkspaceVisibilityPrivateHint: "Only you. No invites.",
      createWorkspaceVisibilityTeam: "Team",
      createWorkspaceVisibilityTeamHint: "Invite specific people.",
      createWorkspaceVisibilityPublic: "Public",
      createWorkspaceVisibilityPublicHint:
        "Anyone with the link can request to join.",
      createFormCancel: "Cancel",
      createFormSubmit: "Create room"
    },
    connector: {
      title: "Connectors",
      vmManaged: "VM managed",
      tabsAria: "Connector tabs",
      tabMcpServers: "MCP Servers",
      tabSkills: "Skills",
      registryReadError: "Could not read host MCP registry: {{detail}}",
      statusApplyingRuntime: "Applying MCP runtime configuration…",
      statusMcpEnabledRuntimeErrors: "MCP enabled with runtime errors",
      installFailedForServer: "{{serverId}} install failed",
      statusMcpRuntimeConfigured: "MCP runtime configured",
      statusMcpRegistrySaved: "MCP registry saved",
      statusSkippedUntilSignedIn: "; skipped until signed in: {{servers}}",
      statusOpeningFigmaSignIn: "Opening Figma sign-in…",
      statusFigmaConnected: "Figma connected",
      statusFigmaDisconnected: "Figma disconnected and removed from agents",
      statusOpeningGoogleSignIn: "Opening Google sign-in…",
      statusGoogleConnected: "Google connected",
      statusGoogleDisconnected:
        "Google connector disconnected and removed from agents",
      statusOpeningNotionSignIn: "Opening Notion sign-in…",
      statusNotionConnected: "Notion connected",
      statusNotionDisconnected: "Notion disconnected and removed from agents",
      builtinSectionTitle: "Built-in MCP",
      builtinSectionSubtitle:
        "Enable shipped servers once; tsh injects them for every agent.",
      enabledCountBadge: "{{count}} enabled",
      toggleApplying: "Applying…",
      toggleEnabled: "Enabled",
      toggleEnable: "Enable",
      builtinFigmaInProgressSuffix: "(connecting)",
      builtinFigmaToggleUnavailable: "Connecting",
      installStatusFailed: "Install failed",
      installStatusRemoteMcp: "Remote MCP",
      installStatusReadyInVm: "Ready in VM",
      authSignedIn: "Signed in",
      authSignInRequired: "Sign-in required",
      disconnect: "Disconnect",
      signIn: "Sign in",
      customServersHeader: "{{count}} custom servers",
      addServerTitle: "Add server",
      serverUntitled: "Untitled server",
      detailStdioCommand: "stdio command",
      detailTransportEndpoint: "{{transport}} endpoint",
      emptyNoCustomServers: "No custom MCP servers yet.",
      addServerCta: "Add server",
      editorNewServerTitle: "New MCP server",
      editorSubtitle: "Custom servers are also available to every agent.",
      deleteServerTitle: "Delete server",
      fieldId: "ID",
      fieldName: "Name",
      fieldTransport: "Transport",
      fieldCommand: "Command",
      fieldArgs: "Args",
      fieldUrl: "URL",
      placeholderServerId: "github",
      placeholderServerName: "GitHub",
      placeholderCommand: "npx",
      placeholderArgs: "-y @modelcontextprotocol/server-github",
      placeholderUrl: "https://example.com/mcp",
      editorEmptyTitle: "No server selected",
      skillSourceBuiltin: "Built-in",
      skillSourceCustom: "Custom",
      noSkillsFound: "No skills found."
    }
  },
  settingsPanel: enSettingsPanel,
  websiteNode: enWebsiteNode,
  terminalNode: {
    resizeWidth: "Resize terminal width",
    resizeHeight: "Resize terminal height"
  },
  terminalCloseGuard: {
    title: "Close this terminal?",
    body: "A process is still running in this terminal. Closing it will stop the session.",
    cancel: "Cancel",
    confirm: "Close terminal"
  },
  terminalFind: {
    placeholder: "Find…",
    previous: "Previous match",
    next: "Next match",
    close: "Close",
    caseSensitive: "Match case",
    useRegex: "Use regular expression"
  },
  terminalNodeHeader: {
    directoryMismatch: "DIR MISMATCH",
    directoryMismatchTitle:
      "Bound directory: {{executionDirectory}}\nCurrent directory: {{expectedDirectory}}"
  },
  nodeDeleteDialog: {
    deleteNodes_one: "Delete {{count}} node?",
    deleteNodes_other: "Delete {{count}} nodes?",
    deleteTask: "Delete Task?",
    deleteNode: "Delete Node?",
    multipleDescription:
      "This will permanently remove {{count}} selected nodes.",
    taskDescriptionPrefix: "This will permanently remove",
    nodeDescriptionPrefix: "This will permanently remove this {{kind}}:"
  },
  workspaceContextMenu: {
    newTerminal: "New Terminal",
    newWebsite: "New Website",
    newTask: "New Task",
    runAgent: "Run Agent",
    runAgentBlank: "Blank",
    runAgentProviderSubmenu: "Choose agent provider",
    convertToTask: "Convert to Task",
    clearSelection: "Clear Selection",
    editSelectedTask: "Edit task…"
  },
  workspaceCanvas: {
    selectionHint_one: "Selected {{count}} window.",
    selectionHint_other: "Selected {{count}} windows.",
    labelColorFilterAll: "Show all",
    clearLabelColorFilter: "Clear label filter",
    chatPillLabel: "#general",
    chatPanelTitle: "Session",
    chatOpenPanel: "Open session panel",
    chatPlaceholder: "Room session is not connected yet.",
    composerStatusMessage: "No agent is running in this room.",
    composerUnreadCompletedPrompt: "Sessions finished — open to review.",
    composerUnreadFailedPrompt: "A session needs attention — open to review.",
    composerWorkingAgentsMessage_one: "{{count}} agent currently running",
    composerWorkingAgentsMessage_other: "{{count}} agents currently running",
    composerWaitingAgentsMessage_one: "{{count}} agent waiting for you",
    composerWaitingAgentsMessage_other: "{{count}} agents waiting for you",
    composerRoomWaitingAgentsMessage_one:
      "{{count}} agent waiting in this room",
    composerRoomWaitingAgentsMessage_other:
      "{{count}} agents waiting in this room",
    composerMessageAriaLabel: "Agent progress status",
    idleDisconnectOverlay: {
      title: "Room paused while idle",
      description:
        "The sandbox was disconnected to save resources. Re-enter to continue working.",
      reenter: "Re-enter room",
      reconnecting: "Re-entering…",
      reentered: "Room re-entered"
    },
    agentActivityConversationSummaryLoadingAria: "Loading session summary",
    newWindow: "New window",
    closeWindowAria: "Close {{title}}",
    websiteWindowTitle: "Website",
    minimizedWindows: "Minimized windows",
    nodeDockToolbarAriaLabel:
      "Workspace panes — quick add Files, terminal, browser, task, or agent; click focuses an open window or creates one if none exists; right-click is New only",
    /** Dock icon tooltips (no “New” — short names only) */
    nodeDockLabel: {
      terminal: "Terminal",
      debugTerminal: "Debug Terminal",
      website: "Browser",
      task: "Task",
      files: "Files",
      agent: "Agent",
      openclaw: "OpenClaw",
      claudeCode: "Claude",
      codex: "Codex",
      nexightAgent: "Tutti Agent"
    },
    dockPopupAgentAvailabilitySectionAria: "Availability status for {{name}}",
    nodeDockContextNew: {
      files: "New room file session",
      terminal: "New terminal",
      debugTerminal: "New debug terminal",
      website: "New browser",
      task: "New task",
      agent: "New agent"
    },
    zoomPercentInputAria:
      "Canvas zoom: enter a percent (e.g. 91 or 91%) or a ratio between 0 and 1; press Enter to apply",
    zoomPercentInputTitle: "Double-click to reset to 100%",
    runtimeStatusPanel: {
      title: "Room runtime",
      openComposerAria: "Open room runtime status",
      close: "Close",
      refresh: "Refresh status",
      workspaceConnection: "Room",
      runtimeConnection: "Workspace environment",
      connected: "Connected",
      disconnected: "Disconnected",
      reconnecting: "Reconnecting…",
      state: "State",
      statusMessage: "Message",
      workspaceRoot: "Room root",
      linuxUser: "Linux user",
      provider: "Provider",
      sandboxId: "Sandbox",
      sandboxSession: "Sandbox session",
      terminals: "Terminal sessions",
      runtimeId: "Runtime ID",
      vsockRelay: "Vsock relay",
      noData: "Status is not available."
    },
    runtimeWorkspaceDebug: {
      title: "Runtime workspace debug",
      close: "Close",
      refresh: "Refresh",
      connected: "Connected",
      disconnected: "Disconnected",
      vmTab: "VM",
      vmOverview: "VM overview",
      runtimeTrace: "VM trace",
      workspaceOverview: "Workspace overview",
      workspaceTrace: "Workspace trace",
      vmBootPhases: "VM boot phases",
      workspaceEnterTraces: "Workspace enter traces",
      workspaceAttachments: "Workspace attachments",
      connection: "Connection",
      state: "State",
      healthState: "Health state",
      imageBootSource: "Image boot source",
      statusMessage: "Status message",
      diagnosticsStatusMessage: "Diagnostics status",
      elapsed: "Elapsed",
      totalElapsed: "Total elapsed",
      attempt: "Attempt",
      sandboxSession: "Sandbox session",
      attachment: "Attachment",
      attached: "Attached",
      detached: "Detached",
      noRuntimeTrace: "No VM trace recorded.",
      noVmBootPhases: "No VM boot phases recorded.",
      noWorkspaceEnters: "No workspace enter traces.",
      noWorkspaceEnterPhases: "No workspace enter phases recorded.",
      noWorkspaceTrace: "No workspace trace recorded.",
      noWorkspaces: "No runtime workspaces.",
      workspaceId: "Workspace ID",
      roomName: "Room name",
      mountState: "Mount state",
      mountPoint: "Mount point",
      sandboxId: "Sandbox ID",
      websocketState: "WebSocket",
      createdAt: "Created",
      lastConnectedAt: "Last connected",
      lastDisconnectedAt: "Last disconnected",
      reconnectCount: "Reconnects",
      lastError: "Last error",
      vmRestartCount: "VM restarts"
    },
    sandboxSessionBanner: {
      reconnecting: "Sandbox reconnecting…",
      disconnected: "Sandbox disconnected"
    },
    applications: {
      eyebrow: "Agent OS apps",
      title: "Applications",
      description:
        "Open the core room apps and preview common Agent OS workflows from one place",
      launchHint: "Mock apps can be opened after you enter a room",
      launchMockUnavailable: "Enter a room to open this mock application",
      categoryBasic: "Basic",
      categoryOffice: "Office",
      categoryCreation: "Creation",
      installAction: "Install",
      comingSoonAction: "Coming soon",
      installedAction: "Installed",
      issueTitle: "Tasks",
      issueDescription:
        "Create, assign, run, and review room tasks with agents",
      vibeDesignTitle: "Vibe design",
      vibeDesignDescription:
        "Draft product screens, interaction states, and visual directions",
      vibeVideoTitle: "Video creating",
      vibeVideoDescription:
        "Shape scripts, storyboards, edits, and final video direction",
      imageGenerationTitle: "Image generation",
      imageGenerationDescription:
        "Create visual concepts, generated assets, and prompt-driven image drafts",
      textEditorTitle: "Document",
      textEditorDescription:
        "Write and revise room notes, prompts, and lightweight documents",
      pptTitle: "PPT",
      pptDescription:
        "Create presentation outlines, slide drafts, and review-ready decks",
      sheetTitle: "Sheet",
      sheetDescription:
        "Track structured data, tables, calculations, and room planning lists",
      calendarTitle: "Calendar",
      calendarDescription:
        "Plan room milestones, follow-ups, reviews, and shared schedules",
      systemMonitorTitle: "System Monitor",
      systemMonitorDescription:
        "Inspect runtime health, resource signals, and workspace activity",
      codeEditorTitle: "Code Editor",
      codeEditorDescription:
        "Open source files, review changes, and prepare implementation notes",
      chatTitle: "Chat",
      chatDescription:
        "Coordinate room sessions, agent handoffs, and quick decisions",
      mockWindowStatus: "Mock application",
      mockWindowReady: "Ready for future integration",
      mockDesignPreviewTitle: "Design board",
      mockDesignPreviewBody:
        "Layout references, component states, and review notes will appear here",
      mockVideoPreviewTitle: "Video timeline",
      mockVideoPreviewBody:
        "Scenes, clips, narration, and export status will appear here",
      mockImageGenerationPreviewTitle: "Image studio",
      mockImageGenerationPreviewBody:
        "Prompts, generated previews, variations, and export history will appear here",
      mockEditorPreviewTitle: "Draft document",
      mockEditorPreviewBody:
        "Start writing room notes and agent prompts in this placeholder editor",
      mockPresentationPreviewTitle: "Slide deck",
      mockPresentationPreviewBody:
        "Slide outlines, narrative beats, and review notes will appear here",
      mockSheetPreviewTitle: "Data sheet",
      mockSheetPreviewBody:
        "Tables, calculations, filters, and room planning data will appear here",
      mockCalendarPreviewTitle: "Room calendar",
      mockCalendarPreviewBody:
        "Milestones, meetings, follow-ups, and shared schedule blocks will appear here",
      mockMonitorPreviewTitle: "Runtime signals",
      mockMonitorPreviewBody:
        "CPU, memory, network, and workspace activity signals will appear here",
      mockCodePreviewTitle: "Source workspace",
      mockCodePreviewBody:
        "Files, diffs, symbols, and implementation notes will appear here",
      mockChatPreviewTitle: "Room chat",
      mockChatPreviewBody:
        "Session threads, agent replies, and shared decisions will appear here"
    },
    vmStatusIndicator: {
      healthy: "VM is running and healthy",
      pending: "VM is running, checking health",
      unhealthy: "VM failed or health check failed"
    }
  },
  labelColors: {
    title: "Label Color",
    autoInherit: "Auto (inherit partition)",
    none: "None",
    gray: "Gray",
    red: "Red",
    orange: "Orange",
    yellow: "Yellow",
    green: "Green",
    blue: "Blue",
    purple: "Purple"
  },
  messages: enMessages
} as const;
